import _axios from '@/utils/request'
// 打卡记录
export function postCheckList (params) {
    return _axios(
        'post',
        `/ms-shulan-hospital/v1/clockIn/clockInList`,
        params
    )
}
// 人脸建档记录
export function postFaceList (params) {
    return _axios(
        'post',
        `/ms-shulan-hospital/v1/account/faceProfileList`,
        params
    )
}
// 获取打卡开关值
export function getCheckData (key) {
    return _axios('get', `/ms-shulan-hospital/v1/configSwitch/getConfigSwitch/${key}`)
}
// 更新打卡开关值
export function postCheckData (params) {
    return _axios(
        'post',
        `/ms-shulan-hospital/v1/configSwitch/updateConfigSwitch`,
        params
    )
}
